import styled from 'styled-components';
import { Box } from '@user-portal/wikr-components';

export const StyledWrapper = styled(Box)`
    margin-bottom: ${({ $mb }) => ($mb ? `${$mb}px` : '0px')};
    label {
        font-weight: 700;
    }

    //rm after padding issue in lib will be fixed
    > * {
        margin-bottom: 20px;
    }
`;
